import type { GetLastSavedSearchResponse, ListUserSavedSearchesResponse } from "./types"
import type { NextRequest } from "@/modules/fetch/types"

import { getResultFromResponse } from "@/modules/apiRequests/handlers"
import { handleFetchError } from "@/modules/fetch/errorHandler"
import { fetcher } from "@/modules/fetch/fetcher"
import { toCamelCaseKeys } from "@/modules/format/object/toCamelCaseKeys"
import { logger } from "@/modules/monitoring/logger"

import { GET_USER_MONO_SAVED_SEARCH_ENDPOINT, GET_USER_SAVED_SEARCHES_ENDPOINT } from "./constants"

export type GetUserSavedSearchesParams = {
  isJobAlertBatchBEnabled?: boolean
  nextRequest?: NextRequest
}

export const getUserSavedSearches = async ({
  isJobAlertBatchBEnabled = false,
  nextRequest,
}: GetUserSavedSearchesParams = {}): Promise<ListUserSavedSearchesResponse> =>
  isJobAlertBatchBEnabled
    ? fetcher(GET_USER_MONO_SAVED_SEARCH_ENDPOINT, {
        nextRequest,
        serviceDomain: "KRAKEND_API",
      })
        .then(
          getResultFromResponse<ListUserSavedSearchesResponse>({
            transformResult: result => {
              const resultInCamelCase = toCamelCaseKeys<GetLastSavedSearchResponse>(result)
              return { savedSearches: [resultInCamelCase.savedSearch] }
            },
          })
        )
        .catch(error => {
          if (error.status === 404) {
            return { savedSearches: [] }
          }
          throw error
        })
        .catch(handleFetchError(GET_USER_MONO_SAVED_SEARCH_ENDPOINT))
        .catch(error => {
          logger.error(error)
          return { savedSearches: [] }
        })
    : fetcher(GET_USER_SAVED_SEARCHES_ENDPOINT, {
        nextRequest,
        requestInit: {
          body: JSON.stringify({
            type: "saved_search",
          }),
          method: "POST",
        },
        serviceDomain: "GATEWAY_API",
      })
        .then(
          getResultFromResponse<ListUserSavedSearchesResponse>({
            transformResult: toCamelCaseKeys<ListUserSavedSearchesResponse>,
          })
        )
        .catch(handleFetchError(GET_USER_SAVED_SEARCHES_ENDPOINT))
